<template>
  <div class="page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/apps/index' }">应用中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/pc/index' }">PC网站</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/pc/links' }">友情链接</el-breadcrumb-item>
      <el-breadcrumb-item>添加友情链接</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <el-form class="middle-form" ref="formRef" :model="pageForm" label-width="120px">
        <el-form-item label="排序">
          <el-input type="number" v-model="pageForm.sort" placeholder="数字越大越靠前"></el-input>
        </el-form-item>
        <el-form-item label="友情链接标题">
          <el-input v-model="pageForm.title" placeholder="请输入友情链接标题"></el-input>
        </el-form-item>
        <el-form-item label="友情链接">
          <el-input v-model="pageForm.url" placeholder="请输入友情链接"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">添 加</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Add',
  data () {
    return {
      pageForm: {
        sort: 0,
        title: '',
        url: ''
      }
    }
  },
  methods: {
    async onSubmit () {
      if (!this.pageForm.title) {
        this.$message.error('请填写友情链接标题')
        return false
      }
      if (!this.pageForm.url) {
        this.$message.error('请填写友情链接')
        return false
      }
      const { data: res } = await this.$http.post('/pc-links', this.pageForm)
      if (res.status === 200) {
        this.$message.success(res.msg)
        await this.$router.push('/admin/apps/pc/links')
      } else {
        this.$message.error(res.msg)
      }
    },
    cancel () {
      this.$router.push('/admin/apps/pc/links')
    },
    // 上传组件返回值
    checkedFiles (data) {
      this.pageForm[data.filed] = data.url
    },
    // 删除已选择文件
    delSelect (field, item, pattern) {
      // 单文件删除
      if (pattern === 'single') {
        this.pageForm[field] = ''
      } else {
        // 多文件删除
        const checkedIndex = this.pageForm[field].findIndex(fileItem => fileItem === item)
        // 如果已包含了该文件则移除文件 和 checked 样式
        this.pageForm[field].splice(checkedIndex, 1)
      }
    }
  }
}
</script>

<style scoped>
.middle-form{
  width: 600px;
  margin-left: auto;
  margin-right: auto;
}
/deep/.el-radio{
  margin-bottom: 14px;
}
</style>
